import { Card, CardContent, Collapse, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import { ExpandLess, ExpandMore, GetApp, Edit, Close, Done, Cached } from '@material-ui/icons';
import { useGenericStyles } from 'common/genericStyles';
import { OperacaoCommonStatus, OfertaPrimariaStatus, GrupoAcesso, Perfil } from 'common/genericTypes';
import { GenericDrawer } from 'components/genericDrawer';
import { GenericToast, GenericToastKind } from 'components/genericToast';
import { Button, LgSpace, MdSpace, SmSpace } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { addCpfCnpjMask } from 'utils/mask';
import { formatCurrencyNumber, formatIntNumber, formatEightDecimalsCurrency } from 'utils/number';
import OperacaoParser, { CustodianteGroup } from 'utils/parsers/operacaoParser';
import { NumberField } from 'm2m.components';
interface LiquidacoesProps {
  precoUnitarioLiquidacao: number;
  debentureId: string;
  instrumentoFinanceiroGuid: string;
  aguardandoLiquidacao: boolean;
  liquidacaoDireta?: boolean;
  onConfirmarLiquidacaoSuccess: () => void;
}

type Props = LiquidacoesProps;

const Liquidacoes: React.FC<Props> = (props) => {
  const {
    precoUnitarioLiquidacao,
    debentureId,
    instrumentoFinanceiroGuid: instrumentoFinanceiroGuid,
    liquidacaoDireta,
    onConfirmarLiquidacaoSuccess,
  } = props;

  const [aguardandoLiquidacao, setAguardandoLiquidacao] = useState(props.aguardandoLiquidacao);
  const [liquidacaoConcluidaToast, setLiquidacaoConcluidaToast] = useState(false);
  const [custodianteGroups, setCustodianteGroup] = useState<CustodianteGroup>();
  const [expandedId, setExpandedId] = useState<string>('');
  const [codigo, setCodigo] = useState<string>('');
  const [openConfirmarLiquidacaoDrawer, setOpenConfirmarLiquidacaoDrawer] = useState(false);

  const dispatch = useDispatch();
  const genericClasses = useGenericStyles();

  const isUsuarioLeitura = useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Leitura);
  const isUsuarioOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Operacoes;
  const postConfirmarLiquidacaoDebenture = useSelector(
    (state: RootState) => state.debentureApi.postConfirmarLiquidacaoDebenture
  );
  const { getOperacoesOfertaPrimaria, getOfertaPrimariaComprovanteDownloadUrl } = useSelector(
    (state: RootState) => state.operacaoApi
  );
  const [editarValorPu, setEditValorPuIcons] = useState(false);
  const [valorPu, setValorPu] = useState<number>(0);

  const editValorPu = (simOuNao: boolean) => {
    setEditValorPuIcons(simOuNao);
  };

  const saveNewValuePu = (simOuNao: boolean) => {
    editValorPu(simOuNao);
    Object.values(custodianteGroups || []).map(custodianteGroup => {
      custodianteGroup.valorTotal = valorPu * custodianteGroup.quantidade
      custodianteGroup.investidores.map((investidor) => (
        investidor.valorTotal = valorPu * custodianteGroup.quantidade
      ))
    });
  };


  const getOperacoes = useCallback(async () => {
    try {
      const result = await getOperacoesOfertaPrimaria(dispatch, { instrumentoFinanceiroId: instrumentoFinanceiroGuid }, true);
      setCodigo(result?.[0].instrumentoFinanceiro.codigo ?? '');
      const custodianteGroup = OperacaoParser.ofertaPrimariaResponseToCustodianteGroup(
        precoUnitarioLiquidacao,
        result.filter(
          (_) =>
            _.status !== OperacaoCommonStatus.Reprovada &&
            _.status !== OperacaoCommonStatus.Concluida &&
            _.status !== OfertaPrimariaStatus.AguardandoConfirmacao
        )
      );
      setCustodianteGroup(custodianteGroup);
    } catch (error) { }
  }, [instrumentoFinanceiroGuid, dispatch, getOperacoesOfertaPrimaria, precoUnitarioLiquidacao]);

  const getComprovanteUrl = async (comprovanteId: string, name: string) => {
    try {
      const result = await getOfertaPrimariaComprovanteDownloadUrl(dispatch, comprovanteId, comprovanteId, true);

      if (result) {
        const link = document.createElement('a');
        link.href = result;
        link.target = '_blank';
        link.download = `Comprovante_${name}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleExpand = (id: string) => {
    setExpandedId(id === expandedId ? '' : id);
  };

  useEffect(() => {
    getOperacoes();
  }, [getOperacoes, precoUnitarioLiquidacao]);

  const handleConfirmarLiquidacao = async () => {
    try {
      await postConfirmarLiquidacaoDebenture(dispatch, debentureId, valorPu, true);
      handleCloseConfirmarLiquidacaoDrawer();
      onConfirmarLiquidacaoSuccess();
      setAguardandoLiquidacao(false);
      setLiquidacaoConcluidaToast(true);
    } catch (error) { }
  };

  const handleOpenConfirmarLiquidacaoDrawer = () => {
    setOpenConfirmarLiquidacaoDrawer(true);
  };

  const handleCloseConfirmarLiquidacaoDrawer = () => {
    setOpenConfirmarLiquidacaoDrawer(false);
  };

  const ConfirmarLiquidacaoDrawer = (
    <GenericDrawer
      opened={openConfirmarLiquidacaoDrawer}
      onClose={handleCloseConfirmarLiquidacaoDrawer}
      title={`Confirmar Liquidação`}
      textContents={[
        {
          text: `Tem certeza que deseja confirmar a liquidação do instrumento financeiro ${codigo}?`,
        },
      ]}
      buttons={[
        {
          buttonText: `Confirmar Liquidação`,
          buttonAction: handleConfirmarLiquidacao,
          buttonColor: 'primary',
        },
        {
          buttonText: 'Cancelar',
          buttonAction: handleCloseConfirmarLiquidacaoDrawer,
        },
      ]}
    />
  );

  return (
    <div>
      <SmSpace />
      {liquidacaoConcluidaToast && (
        <>
          <GenericToast kind={GenericToastKind.Success} onDismiss={() => setLiquidacaoConcluidaToast(false)}>
            <Typography variant="body2" display={'inline'}>
              {'Instrumento financeiro liquidado com sucesso.'}
            </Typography>
          </GenericToast>
          <MdSpace />
        </>
      )}
      {!!precoUnitarioLiquidacao && (
        <>
          <Grid container direction="row" alignItems="center" spacing={1}>
            <Grid item>
              <Typography variant="body1">{`PU de Liquidação: `}</Typography>
            </Grid>
            <Grid item>
              {editarValorPu ? (
                <NumberField
                  label={'Valor PU'}
                  value={valorPu > 0 ? valorPu : precoUnitarioLiquidacao}
                  onChange={(value) => setValorPu(value ?? 0)}
                  numberType="eightDecimals"
                />
              ) : (
                <Typography variant="body1">{`${formatEightDecimalsCurrency(valorPu > 0 ? valorPu : precoUnitarioLiquidacao)}`}</Typography>
              )}
            </Grid>
            <SmSpace />
            <Grid item>
              {editarValorPu && custodianteGroups && Object.keys(custodianteGroups).length > 0 ? (
                <>
                  <IconButton onClick={() => saveNewValuePu(false)}>
                    <Done />
                  </IconButton>
                  <IconButton onClick={() => editValorPu(false)}>
                    <Close />
                  </IconButton>
                  <IconButton onClick={() => setValorPu(precoUnitarioLiquidacao)}>
                    <Cached />
                  </IconButton>

                </>
              ) : (custodianteGroups && Object.keys(custodianteGroups).length > 0 && (
                <IconButton onClick={() => editValorPu(true)}>
                  <Edit />
                </IconButton>
              )
              )}
            </Grid>
          </Grid>

        </>
      )}
      {custodianteGroups &&
        Object.values(custodianteGroups)?.map((custodianteGroup) => (
          <Card key={custodianteGroup.cpfCnpjCustodiante} variant="outlined" style={{ margin: '10px 0' }}>
            <CardContent style={{ paddingBottom: 16 }}>
              <div style={{ display: 'flex' }}>
                <Grid container spacing={3}>
                  <Grid item md={2}>
                    <Typography variant="body2">{addCpfCnpjMask(custodianteGroup.cpfCnpjCustodiante ?? '')}</Typography>
                  </Grid>
                  <Grid item md={4} style={{ overflow: 'hidden' }}>
                    <Typography variant="body2" className={genericClasses.wrapTxt}>
                      {custodianteGroup.razaoSocialCustodiante}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body2">{formatIntNumber(custodianteGroup.quantidade)}</Typography>
                  </Grid>
                  <Grid item md>
                    <Typography variant="body2">{formatCurrencyNumber(custodianteGroup.valorTotal)}</Typography>
                  </Grid>
                </Grid>
                <IconButton
                  aria-expanded={expandedId === custodianteGroup.cpfCnpjCustodiante}
                  size="small"
                  onClick={() => handleExpand(custodianteGroup.cpfCnpjCustodiante ?? '')}
                  style={{ float: 'right' }}
                >
                  {expandedId === custodianteGroup.cpfCnpjCustodiante ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </div>
            </CardContent>
            <Collapse in={expandedId === custodianteGroup.cpfCnpjCustodiante} timeout="auto" unmountOnExit>
              <CardContent style={{ paddingTop: 0 }}>
                <div style={{ height: 16 }}></div>
                <>
                  <Grid container>
                    <Grid item md={2}>
                      <Typography variant="body1">{'CPF/CNPJ'}</Typography>
                    </Grid>
                    <Grid item md={2}>
                      <Typography variant="body1">{'Razão Social'}</Typography>
                    </Grid>
                    <Grid item md={2}>
                      <Typography variant="body1">{'Conta Depósito'}</Typography>
                    </Grid>
                    <Grid item md={2}>
                      <Typography variant="body1">{'Quantidade'}</Typography>
                    </Grid>
                    <Grid item md={2}>
                      <Typography variant="body1">{'Valor Total'}</Typography>
                    </Grid>
                    <Grid item md={2}>
                      <Typography variant="body1">{'Comprovante'}</Typography>
                    </Grid>
                  </Grid>
                  <SmSpace />
                  <Divider />
                  <SmSpace />
                  {custodianteGroup.investidores.map((investidor) => (
                    <React.Fragment key={investidor.id}>
                      <Grid container>
                        <Grid item md={2}>
                          <Typography variant="body2">{addCpfCnpjMask(investidor.cpfCnpj)}</Typography>
                        </Grid>
                        <Grid item md={2} style={{ overflow: 'hidden' }}>
                          <Typography variant="body2" className={genericClasses.wrapTxt}>
                            {investidor.razaoSocial}
                          </Typography>
                        </Grid>
                        <Grid item md={2}>
                          <Typography variant="body2">{investidor.contaDeposito}</Typography>
                        </Grid>
                        <Grid item md={2}>
                          <Typography variant="body2">{formatIntNumber(investidor.quantidade)}</Typography>
                        </Grid>
                        <Grid item md={2}>
                          <Typography variant="body2">{formatCurrencyNumber(investidor.valorTotal)}</Typography>
                        </Grid>
                        <Grid item md={2}>
                          {investidor.comprovanteId ? (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                alignContent: 'flex-end',
                                textAlign: 'right',
                              }}
                            >
                              <Button
                                startIcon={<GetApp />}
                                onClick={() => getComprovanteUrl(investidor.comprovanteId!, investidor.cpfCnpj)}
                                variant="text"
                              >
                                {'Download'}
                              </Button>
                            </div>
                          ) : (
                            <Typography variant="body2">{'Sem comprovante.'}</Typography>
                          )}
                        </Grid>
                      </Grid>
                      <SmSpace />
                    </React.Fragment>
                  ))}
                </>
              </CardContent>
            </Collapse>
          </Card>
        ))}
      {isUsuarioOperacoes && !isUsuarioLeitura && aguardandoLiquidacao && liquidacaoDireta && (
        <>
          <SmSpace />
          <Grid container justify="center">
            <Button onClick={handleOpenConfirmarLiquidacaoDrawer} variant="contained" color="primary">
              {'Confirmar Liquidação'}
            </Button>
          </Grid>
        </>
      )}
      <LgSpace />
      {ConfirmarLiquidacaoDrawer}
    </div>
  );
};

export default Liquidacoes;
